export default "__VITE_ASSET__DV1z3aGR__"